import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'next-i18next';

import WhaySkilllaneSectionStyle from './style';

import IconText from '@components/atoms/iconText';

const WhaySkilllaneSection = () => {
  const { t } = useTranslation('common');

  return (
    <WhaySkilllaneSectionStyle>
      <Box className="container">
        <Typography color="#164843" variant="h1" className="topic">
          {t('cpd.common.why.skilllanecpd.title')}
        </Typography>
        <Typography color="rgba(0, 0, 0, 0.6);" variant="h4" className="sub-topic">
          {t('cpd.common.why.skilllanecpd.description')}
        </Typography>
        <Box className="icon-group">
          <IconText
            alt={t('cpd_landing.guarantee.by.oic.and.tsi')}
            icon="/assets/cpd-landing/01-icon-compulsory"
            title="Compulsory Courses"
            content={t('cpd_landing.guarantee.by.oic.and.tsi')}
            className="icon1"
          />
          <IconText
            alt={t('e-certificate.title')}
            icon="/assets/cpd-landing/02-icon-certificate"
            title="e-certificate"
            content={t('e-certificate.content')}
            className="icon2"
          />
          <IconText
            alt={t('time_manager.title')}
            icon="/assets/cpd-landing/03-time-manager"
            title={t('time_manager.title')}
            content={t('time_manager.content')}
            className="icon3"
          />
          <IconText
            alt={t('every_device.title')}
            icon="/assets/cpd-landing/04-everydevices"
            title={t('every_device.title')}
            content={t('every_device.content')}
            className="icon4"
          />
          <IconText
            alt={t('cpd_course.prepare.title.suitable_environment')}
            icon="/assets/cpd-landing/05-Environment"
            title={t('cpd_course.prepare.title.suitable_environment')}
            content={t('cpd_course.prepare.subtitle.suitable_environment')}
            className="icon5"
          />
        </Box>
      </Box>
    </WhaySkilllaneSectionStyle>
  );
};

export default WhaySkilllaneSection;
